import React from 'react';
import WarehouseBasicInfoComponent from './ware-house-basic-info.component';
import WarehouseAddressComponent from './ware-house-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function WarehouseComponent ({ handleFormSubmit,back,stores, handleInnerbasicFormChange,  onInnerFormChange, selectedAddress, selectedWarehouse }: any) {

    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component:  <WarehouseBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            selectedWarehouse={selectedWarehouse}
            stores={stores}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <WarehouseAddressComponent
            handleInnerbasicFormChange={handleInnerbasicFormChange} 
            selectedAddress={selectedAddress} 
            onInnerFormChange={onInnerFormChange}
            selectedWarehouse={selectedWarehouse}
            />,
            isVisible:true,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default WarehouseComponent;
